import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

/* ============================================================
   PÚBLICAS
   ============================================================ */

/**
 * Lista clubes publicados. Opcionalmente filtrar por asociacionId.
 * @param {object} opts - { asociacionId?: number }
 */
export async function listarClubes({ asociacionId = null } = {}) {
  const params = {};
  if (asociacionId) params.asociacionId = asociacionId;
  const res = await api.get("/clubes", { params });
  return res.data; // { items, total }
}

/**
 * Obtiene un club por id (incluye galería parseada).
 */
export async function obtenerClub(id) {
  const res = await api.get(`/clubes/${id}`);
  return res.data;
}

/* ============================================================
   ADMIN
   ============================================================ */

export async function listarClubesAdmin({ asociacionId = null, status = null } = {}) {
  const params = {};
  if (asociacionId) params.asociacionId = asociacionId;
  if (status) params.status = status;
  const res = await apiAuth.get("/clubes/admin/all", { params });
  return res.data; // { items, total }
}

export async function crearClub(payload) {
  const res = await apiAuth.post("/clubes", payload);
  return res.data;
}

export async function editarClub(id, payload) {
  const res = await apiAuth.put(`/clubes/${id}`, payload);
  return res.data;
}

export async function eliminarClub(id) {
  const res = await apiAuth.delete(`/clubes/${id}`);
  return res.data;
}

export async function eliminarClubes(ids, batchSize = 10) {
  const failed = [];
  let deleted = 0;

  for (let index = 0; index < ids.length; index += batchSize) {
    const batch = ids.slice(index, index + batchSize);
    const results = await Promise.allSettled(batch.map((id) => eliminarClub(id)));

    results.forEach((result, resultIndex) => {
      if (result.status === "fulfilled") deleted += 1;
      else failed.push({ id: batch[resultIndex], error: result.reason });
    });
  }

  return { deleted, failed };
}

/* ============================================================
   UPLOADS
   ============================================================ */

export async function subirClubLogo(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/clubes/${id}/logo`, formData);
  return res.data; // { url, club }
}

export async function subirClubHero(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/clubes/${id}/hero`, formData);
  return res.data; // { url, club }
}

export async function agregarImagenGaleria(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/clubes/${id}/gallery`, formData);
  return res.data; // { url, gallery }
}

export async function eliminarImagenGaleria(id, url) {
  const res = await apiAuth.delete(`/clubes/${id}/gallery?url=${encodeURIComponent(url)}`);
  return res.data; // { message, gallery }
}
